import baseUrl from '@pocapan/shared/utils/baseUrl';
import getToken from '@pocapan/shared/utils/getToken';

export default async function addTags({ taggableType, taggableId, tagNames }) {
  return fetch(`${baseUrl()}/api/v1/tags`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${getToken()}`
    },
    body: JSON.stringify({
      tag: {
        taggable_id: taggableId,
        taggable_type: taggableType,
        names: tagNames
      }
    })
  });
}
